import * as React from 'react'
import { Separator } from '@/components/ui/separator'
import { ToolbarButton } from '../toolbar-button'
import {
  CopyIcon,
  ExternalLinkIcon,
  LinkBreak2Icon,
} from '@radix-ui/react-icons'

interface LinkPopoverBlockProps {
  url: string
  onClear: () => void
  onEdit: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const LinkPopoverBlock: React.FC<LinkPopoverBlockProps> = ({
  url,
  onClear,
  onEdit,
}) => {
  const [copyTitle, setCopyTitle] = React.useState<string>('Copy')

  const handleCopy = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setCopyTitle('Copied!')
          setTimeout(() => setCopyTitle('Copy'), 1000)
        })
        .catch(console.error)
    },
    [url],
  )

  const handleOpenLink = React.useCallback(() => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }, [url])

  return (
    <div className='bg-background flex overflow-hidden rounded p-2 shadow-lg'>
      <div className='inline-flex items-center gap-1'>
        <ToolbarButton tooltip='Edit link' onClick={onEdit}>
          Edit link
        </ToolbarButton>
        <Separator orientation='vertical' />
        <ToolbarButton
          tooltip='Open link in a new tab'
          onClick={handleOpenLink}
        >
          <ExternalLinkIcon />
        </ToolbarButton>
        <Separator orientation='vertical' />
        <ToolbarButton tooltip='Clear link' onClick={onClear}>
          <LinkBreak2Icon />
        </ToolbarButton>
        <Separator orientation='vertical' />
        <ToolbarButton
          tooltip={copyTitle}
          onClick={handleCopy}
          tooltipOptions={{
            onPointerDownOutside: (e) => {
              if (e.target === e.currentTarget) e.preventDefault()
            },
          }}
        >
          <CopyIcon />
        </ToolbarButton>
      </div>
    </div>
  )
}
